import { toJS } from 'mobx';

export class StrategyRequests {
  #requestsStatus = {
    return: 'return',
    send: 'send',
    decline: 'decline',
    approve: 'approve',
    achieve: 'achieve',
  };

    #store
    #stratId
    #api
    #addToast
    constructor({stratId,api,addToast,store}) {
        this.#stratId = Number(stratId)
        this.#api = api
        this.#addToast = addToast
        this.#store = store
    }

  promiseAddPlanResult = async() => {
      await this.#store.strategies.addPlanResults(this.#stratId)
  }

  savePlanResults = async () => {
    const res = await this.#api.post(`/strategies/${this.#stratId}/results/0/plan`, toJS(this.#store.strategies.planResults));
    const resultOrdered = [...res.filter((x) => !x.hasOwnProperty('parentId')), ...res.filter((x) => x.hasOwnProperty('parentId'))];
    const allFiles = this.#indexingUploadFiles();
    const promise = Promise.all(resultOrdered.map((async (x, index) => this.#handleUploadFiles(x.id, index, allFiles, true))));
    promise.then(() => this.#store.strategies.clearFilters()).then(async (x) => this.updateAllPlanResults()).catch(() => {
      this.#addToast.error('Неверный ввод файлов');
    });
  };

  saveFactResults = async (resultId, milestoneId = null) => {
    const currentId = milestoneId || resultId;
    const currentFact = milestoneId
      ? this.#store.strategies.planResults.filter((x) => x.id === resultId)[0].milestones.filter((m) => m.id === milestoneId)[0]
      : this.#store.strategies.planResults.filter((x) => x.id === resultId)[0];
    const objPost = {
      id: currentFact?.id,
      result: currentFact?.result || (
											currentFact.projMilestones && currentFact.projMilestones.length > 0 ?
                    	'В проектах, в которые назначена данный результат, заполнены факты:\n' + currentFact.projMilestones.filter(milestone => !!milestone.result).map((milestone, i) => `${milestone.projs[0].fullNumber}. ${milestone.result}`).join('\n') :
											''
										),
      trlFactId: currentFact?.trlFactId,
      monthFact: currentFact?.monthFact,
      yearFact: currentFact?.yearFact,
      personsInCharge: currentFact?.personsInCharge,
      projs: currentFact?.projs
    };
    if(objPost.result.replaceAll(' ', '').length <= 1500){
      const res = this.#api.post(`/strategies/${this.#stratId}/results/${currentId}/fact`, objPost);
      const allFiles = new Array(currentFact.files);
      return this.#handleUploadFiles(currentId, 0, allFiles, false).then(()=>res.then(() => this.updateAllPlanResults()));
    }
    else{
      return Promise.reject('Result error')
    }
    // return res.then(async (x) => this.updateAllPlanResults());
  };

  updateAllPlanResults = async () => {
    const [yearStr, yearMileStr, status] = [
      this.#store.strategies.filters.dateResults ? `&year=${this.#store.strategies.filters.dateResults}` : '',
      this.#store.strategies.filters.dateMilestones ? `&yearMilestone=${this.#store.strategies.filters.dateMilestones}` : '',
      this.#store.strategies.filters.status ? `&status=${JSON.stringify(this.#store.strategies.filters.status)}&statusMilestone=${JSON.stringify(this.#store.strategies.filters.status)}` : '',
    ];
    const filterStr = `${this.#store.strategies.filters.year !== 'null' ? yearStr : ''}${this.#store.strategies.filters.dateMilestones !== 'null' ? yearMileStr : ''}${this.#store.strategies.filters.status !== 'null' ? status : ''}`;
    const allTable = this.#api
      .get(`/strategies/${this.#stratId}/results?full=true${filterStr}`).then((x) => {
        const correctProjsIdPlans = x.map(res => {
          if(res.milestones){
            res.milestones = res.milestones.map(milestone => ({...milestone, projs: milestone.projs ? milestone.projs.map(proj => ({...proj, id: proj.originId})) : []}))
          }
          return {...res, projs: res.projs ? res.projs.map(proj => ({...proj, id: proj.originId})) : []}
        })
        this.#store.strategies.setPlanResults(correctProjsIdPlans);
      });

    return allTable;
  };

  #updateCurrentPlanResults = async (resultId) => {
    const currentResult = this.#api.get(`/strategies/${this.#stratId}/results/${resultId}`).then((x) => {
      this.#store.strategies.setCurrentPlanResult(resultId, x);
    });
    return currentResult;
  };

  handleAddResult = async () => {
    const data = await this.#api.get('/mng/trls').then((x) => this.#store.strategies.setTrls(x));
    return data;
  };

  deleteFile = async (id, resultId) => {
    const url = `/strategies/${this.#stratId}/results/${resultId}/files/${id}`;
    await this.#api.del(url, {}).then((x) => {
      if (!x.success) {
        this.#addToast.error('Файл не удалось удалить');
      }
    });
  };

  handleSubmitForm = async (event, formEl, action, callback, isEdit = false, resultId = null, mileStoneId = null) => {
    const checkValidatyInForm = (value, isResult) => {
      if (!value.personsInCharge[0] && !value.projs[0]) {
        this.#addToast.error('Введите ответственных');
        return false;
      }
      if (isEdit && (isResult && !mileStoneId && !value.yearFact) || (!isResult && !!mileStoneId && !value.yearFact)) {
        this.#addToast.error('Введите дату факта');
        return false;
      }
      if (!isEdit && (!value.yearPlan)) {
        this.#addToast.error('Введите дату плана');
        return false;
      }
      return true;
    };

    event?.preventDefault();
    event?.stopPropagation();
    const allPlans = isEdit ? this.#store.strategies.planResults.filter((x) => x?.id === Number(resultId)) : this.#store.strategies.planResults;
    for (const value of allPlans) {
      const milestones = (isEdit && !!mileStoneId) ? value.milestones.filter((x) => x.id === +mileStoneId) : value.milestones;
      if (!checkValidatyInForm(value, true)) {
        return;
      }
      for (const mileStone of milestones) {
        if (!checkValidatyInForm(mileStone, false)) {
          return;
        }
      }
    }
    const form = event?.currentTarget;
    if (form?.checkValidity() === false || (isEdit && formEl.current.checkValidity() === false)) {
      const invalidEl = formEl?.current.querySelector(':invalid');
      invalidEl?.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } else {
      this.#store.strategies.isLoading = true
      action()
        .then((x) => this.#addToast.success(isEdit ? 'Фактические значения сохранены' : 'Планы сохранены'))
        .catch((x) => {
          if(x !== 'Result error'){
            this.#addToast.error(isEdit ? 'Произошла ошибка при сохранении фактов' : 'Произошла ошибка при сохранении планов');
          }
        })
        .finally(() => this.#store.strategies.isLoading = false);
    }
    callback(true);
  };

  #indexingUploadFiles = () => {
    const tmpPlanRes = toJS(this.#store.strategies.planResults.sort((x, y) => Number(x.orderNum) - Number(y.orderNum)) || []);
    const resultFiles = [];
    for (const plan of tmpPlanRes) {
      resultFiles.push([...plan.files]);
    }
    for (const plan of tmpPlanRes) {
      if (plan.milestones.length > 0) { resultFiles.push(...plan.milestones.slice().sort((x, y) => Number(x.orderNum) - Number(y.orderNum)).map((x) => x.files)); }
    }
    return resultFiles;
  };

  #handleUploadFiles = async (resultId, index, allFiles, isPlan) => {
    const tmpPlanRes = allFiles[index];
    const url = `/strategies/${this.#stratId}/results/${+resultId}/files`;
    const results = [];
    try {
      for (const value of Object.values(tmpPlanRes)) {
        if (value instanceof File) {
          results.push(this.#api.postFormData(url, { isPlan }, value));
        }
      }
      await Promise.all(results);
      return true;
    } catch (error) {
      return false;
    }
  };

  getOptions = async (inputValue, callback) => {
    if (!inputValue || inputValue.length < 3) {
      return callback([]);
    }
    const result = await this.#api.get(`/users/employees?name=${inputValue.trim()}`);
    callback(this.#mapOptionsToValues(result));
  };

  // eslint-disable-next-line class-methods-use-this
  #mapOptionsToValues = (options) =>
  // value, label, isFixed, isDisabled
    options.map((option) => ({
      value: option.id,
      label: `${option.lastName || ''} ${option.firstName || ''} ${option.middleName || ''} (${option.post || 'должность не указана'})`,
      user: option,
    }));

  updatePlanResults = (e) => {
    this.#store.strategies.changePlanResults(...e);
  };

  deletePlan = (element) => {
    this.#store.strategies.deletePlanResults(element);
  };

  sendToProjOffice = async (resultId) => {
    this.changeStatus(resultId, 'send')
      .then(() => this.#addToast.success('Вы отправили результаты в проектный офис'))
      .catch((err) => this.#addToast.error('Неверная последовательность статусов'));
  };

  changeStatus = async (resultId, status, value) => {
    const currentStatusPost = this.#requestsStatus[status];
    if (currentStatusPost) {
      this.#api.post(`/strategies/${this.#stratId}/results/${resultId}/${currentStatusPost}`, value)
        .then(async (x) => this.updateAllPlanResults());
    }
  };

  isStrategyContainsResults() {
    return this.#api.get(`/strategies/${this.#stratId}/results`);
  }
}
